export const TWG_CLI_LEARN_MORE_URL =
  'https://developer.atlassian.com/cloud/twg-cli/';
